import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Trophy, ChevronRight } from 'lucide-react';

function PlayerStats() {
  const navigate = useNavigate();

  return (
    <div className="bg-gradient-to-r from-[#0F172A] to-[#1E293B] rounded-xl shadow-lg p-4 mb-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Trophy className="w-5 h-5 text-amber-400" />
          <span className="text-white font-semibold">Player Awards</span>
        </div>
        
        <Button 
          onClick={() => navigate('/awards')}
          variant="outline" 
          size="sm" 
          className="bg-white/10 border-white/20 text-white hover:bg-white/20"
          data-testid="view-awards-btn"
        >
          View Awards
          <ChevronRight className="w-4 h-4 ml-1" />
        </Button>
      </div>

      {/* Quick preview badges */}
      <div className="flex gap-2 mt-3 overflow-x-auto pb-1">
        <span className="flex items-center gap-1 bg-white/10 rounded-full px-3 py-1.5 text-white text-sm whitespace-nowrap">
          <span>🍳</span> Breakfast Paglu
        </span>
        <span className="flex items-center gap-1 bg-white/10 rounded-full px-3 py-1.5 text-white text-sm whitespace-nowrap">
          <span>👻</span> Ghost
        </span>
        <span className="flex items-center gap-1 bg-white/10 rounded-full px-3 py-1.5 text-white text-sm whitespace-nowrap">
          <span>⚡</span> Fastest Fingers
        </span>
      </div>
    </div>
  );
}

export default PlayerStats;
